import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import { Link } from 'react-router-dom';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from './../../firebase/firebaseConfig';; // Adjust import path as needed

const Orders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersCollection = collection(db, 'Orders');
        const q = query(ordersCollection, orderBy('orderDate', 'desc')); // Sort by orderDate in descending order
        const querySnapshot = await getDocs(q);
        
        const fetchedOrders = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setOrders(fetchedOrders);
      } catch (error) {
        console.error('Error fetching orders: ', error);
      }
    };

    fetchOrders();
  }, []);

  return (
    <>
      <PageTitle title="Orders - ALMOSTINVISIBLE" />
      <Layout>
        <div className="container mt-5">
          <h2 className='unbounded'>Orders</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Order ID</th>
                <th scope="col">Order Name</th>
                <th scope="col">Email</th>
                <th scope="col">View Details</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <th scope="row">{order.id}</th>
                  <td>{order.firstname} {order.lastname}</td> {/* Assuming name is composed of firstname and lastname */}
                  <td>{order.email}</td>
                  <td>
                    <Link className='black-button p' style={{fontSize: "12px"}} to={`/a/order/${order.id}`}>
                      Order Details
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Layout>
    </>
  );
};

export default Orders;
